import {
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Switch,
} from "@material-ui/core";
import React from "react";
import {
  FieldTitle,
  InputHelperText,
  sanitizeInputRestProps,
} from "react-admin";
import { Controller, FieldValues } from "react-hook-form";
import { HookFormInputProps } from "./HookFormInputProps";

interface Props<TRecord> extends HookFormInputProps<TRecord> {
  disabled?: boolean;
  onChange?: (value: boolean) => void;
  style?: any;
}

declare module "react" {
  function forwardRef<T, P = {}>(
    render: (props: P, ref: React.Ref<T>) => React.ReactElement | null
  ): (props: P & React.RefAttributes<T>) => React.ReactElement | null;
}

const HookFormBooleanInputComponent = <TRecord extends FieldValues>(
  {
    control,
    name,
    defaultValue,
    label,
    rules,
    disabled,
    onChange,
    options,
    ...props
  }: Props<TRecord>,
  ref: React.Ref<HTMLButtonElement>
) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue ?? false}
      rules={rules}
      render={(renderProps) => (
        <FormGroup {...sanitizeInputRestProps(props)}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                {...renderProps.field}
                {...options}
                ref={ref}
                inputRef={renderProps.field.ref}
                checked={renderProps.field.value}
                onChange={(event, checked) => {
                  renderProps.field.onChange(event);
                  if (onChange) {
                    onChange(checked);
                  }
                }}
              />
            }
            label={
              <FieldTitle
                label={label}
                source={name}
                isRequired={!!rules?.required}
              />
            }
          />
          <FormHelperText error={!!renderProps.fieldState.error}>
            <InputHelperText
              touched={renderProps.fieldState.isTouched}
              error={(renderProps.fieldState.error as any)?.message}
              helperText={
                (renderProps.fieldState.error as any)?.message as string
              }
            />
          </FormHelperText>
        </FormGroup>
      )}
    />
  );
};

export const HookFormBooleanInput = React.forwardRef(
  HookFormBooleanInputComponent
);
